// Main idea to generate multiple charts in one page:
// http://jsfiddle.net/no1uknow/Jb2cb/2/

<template>
  <div id="chartdiv" class="elevation-5">
    <div v-if="!errorModal">
      <v-progress-linear style="margin: 0px" :indeterminate="loading" v-show="graphShown" :color="loading ? 'blue' : 'rgba(0,0,0,0)'"></v-progress-linear>
      <v-alert color="error" icon="priority_high" value="true" v-show="hasError" v-html="errorHtml"></v-alert>
      <div :id="id" v-show="errorHtml === null">
        <v-flex xs12 md12>
          <v-layout row style="padding: 25px 0;">
            <v-flex xs6 mt8>
              <div v-show="hasData(0)" id="chartdiv0"></div>
            </v-flex>
            <v-flex xs6>
              <div v-show="hasData(1)" id="chartdiv1"></div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 md12>
          <v-layout row style="padding: 25px 0;">
            <v-flex xs6 mt8>
              <div v-show="hasData(2)" id="chartdiv2"></div>
            </v-flex>
            <v-flex xs6>
              <div v-show="hasData(3)" id="chartdiv3"></div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 md12>
          <v-layout row style="padding: 25px 0;">
            <v-flex xs6 mt8>
              <div v-show="hasData(4)" id="chartdiv4"></div>
            </v-flex>
            <v-flex xs6>
              <div v-show="hasData(5)" id="chartdiv5"></div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 md12>
          <v-layout row style="padding: 25px 0;">
            <v-flex xs6 mt8>
              <div v-show="hasData(6)" id="chartdiv6"></div>
            </v-flex>
            <v-flex xs6>
              <div v-show="hasData(7)" id="chartdiv7"></div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 md12 mt4>
          <v-layout row style="padding: 25px 0;">
            <v-flex xs6>
              <div v-show="hasData(8)" id="chartdiv8"></div>
            </v-flex>
            <v-flex xs6>
              <div v-show="hasData(9)" id="chartdiv9"></div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 md12 mt4>
          <v-layout row style="padding: 25px 0;">
            <v-flex xs6>
              <div v-show="hasData(10)" id="chartdiv10"></div>
            </v-flex>
            <v-flex xs6>
              <div v-show="hasData(11)" id="chartdiv11"></div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 md12 mt4>
          <v-layout row style="padding: 25px 0;">
            <v-flex xs6>
              <div v-show="hasData(12)" id="chartdiv12"></div>
            </v-flex>
            <v-flex xs6>
              <div v-show="hasData(13)" id="chartdiv13"></div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 md12 mt4>
          <v-layout row style="padding: 25px 0;">
            <v-flex xs6>
              <div v-show="hasData(14)" id="chartdiv14"></div>
            </v-flex>
            <v-flex xs6>
              <div v-show="hasData(15)" id="chartdiv15"></div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 md12 mt4>
          <v-layout row style="padding: 25px 0;">
            <v-flex xs6>
              <div v-show="hasData(16)" id="chartdiv14"></div>
            </v-flex>
            <v-flex xs6>
              <div v-show="hasData(17)" id="chartdiv15"></div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 md12 mt4>
          <v-layout row style="padding: 25px 0;">
            <v-flex xs6>
              <div v-show="hasData(18)" id="chartdiv16"></div>
            </v-flex>
            <v-flex xs6>
              <div v-show="hasData(19)" id="chartdiv17"></div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 md12 mt4>
          <v-layout row style="padding: 25px 0;">
            <v-flex xs6>
              <div v-show="hasData(18)" id="chartdiv18"></div>
            </v-flex>
            <v-flex xs6>
              <div v-show="hasData(19)" id="chartdiv19"></div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 md12 mt4>
          <v-layout row style="padding: 25px 0;">
            <v-flex xs6>
              <div v-show="hasData(18)" id="chartdiv20"></div>
            </v-flex>
            <v-flex xs6>
              <div v-show="hasData(19)" id="chartdiv21"></div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 md12 mt4>
          <v-layout row style="padding: 25px 0;">
            <v-flex xs6>
              <div v-show="hasData(18)" id="chartdiv22"></div>
            </v-flex>
            <v-flex xs6>
              <div v-show="hasData(19)" id="chartdiv23"></div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 md12 mt4>
          <v-layout row style="padding: 25px 0;">
            <v-flex xs6>
              <div v-show="hasData(18)" id="chartdiv24"></div>
            </v-flex>
            <v-flex xs6>
              <div v-show="hasData(19)" id="chartdiv25"></div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 md12 mt4>
          <v-layout row style="padding: 25px 0;">
            <v-flex xs6>
              <div v-show="hasData(18)" id="chartdiv26"></div>
            </v-flex>
            <v-flex xs6>
              <div v-show="hasData(19)" id="chartdiv27"></div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 md12 mt4>
          <v-layout row style="padding: 25px 0;">
            <v-flex xs6>
              <div v-show="hasData(18)" id="chartdiv28"></div>
            </v-flex>
            <v-flex xs6>
              <div v-show="hasData(19)" id="chartdiv29"></div>
            </v-flex>
          </v-layout>
        </v-flex>
      </div>
      <v-progress-linear style="margin: 0px" :indeterminate="loading" v-show="graphShown" :color="loading ? 'blue' : 'rgba(0,0,0,0)'"></v-progress-linear>
    </div>


    <ChartErrorModal v-model="errorModal" :data="errorModalData" @cancel="onErrorModalClose"  />
  </div>
</template>

<script>
  import Highcharts from 'highcharts'
  import 'highcharts/modules/exporting'
  import 'highcharts/modules/offline-exporting'
  import DataCharts from '@/components/mixins/DataCharts'
  import axios from 'axios'
  import moment from 'moment'
  import MomentUtil from '@/components/mixins/MomentUtil'
  import { newDateStringNoTimezone, newDateStringNoTimezoneAddOneDay } from '@/components/mixins/MomentUtil'
  import { createNamespacedHelpers } from 'vuex'
  import ChartErrorModal from '@/components/generic/ChartErrorModal'
  const imports = createNamespacedHelpers('imports')
  const authenticate = createNamespacedHelpers('authenticate')


  export default {
    components: {
      ChartErrorModal,
    },
    mixins: [DataCharts, MomentUtil],
    props: {
      graphRequestData: { type: Object },
      id: { type: String },
    },
    data() {
      return {
        loading: false,
        hasError: false,
        errorHtml: null,
        graphShown: false,
        standardData: [],
        rawGraphData: [],
        clone_container: null,
        clone_tooltip: null,
        errorModal: false,
        errorModalData: {},
        guidelineLineColor: '#cccccc',
        exceedancePointColor: '#FF0000',
      }
    },
    computed: {
      ...imports.mapGetters(['importlist']),
      ...authenticate.mapGetters(['currentUserGroup']),
    },
    watch: {
      graphRequestData() {
        this.loading = true
        this.graphShown = true
        this.generateDashCharts()
      },
    },
    methods: {
      constructArgumentForSingleDataset(dataset, index) {
        var timeSeriesColor = Highcharts.getOptions().colors[index % 10]
        var dataSetConfig = {
          name: dataset.AnalyteName,
          type: 'line',
          yAxis: index,
          color: timeSeriesColor,
        }
        var yAxisConfig = {
          labels: {
            format: '',
            style: {
              color: timeSeriesColor,
            },
          },
          title: {
            text: dataset.AnalyteName,
            style: {
              color: timeSeriesColor,
            },
          },
        }

        return {
          dataset: dataSetConfig,
          yAxis: yAxisConfig,
        }
      },
      async fetchDashGraphsData(args, datasetsArgs, requestData) {
        var data = []
         // Customize the default colors
        Highcharts.getOptions().colors = [
          '#7cb5ec', // Light blue
          '#434348', // Dark gray
          '#90ed7d', // Light green
          '#ff9326', // Light orange
          '#8085e9', // Light purple
          '#330066', // Light pink
          '#e4d354', // Light yellow
          '#2b908f', // Teal
          '#53e3d4', // Light red
          '#91e8e1',  // Light cyan
        ]
         
        var url = 'api/WaterQuality/FetchDashGraphsData'
        await axios.post(url, requestData).then((res) => {
          this.analytesData = res.data.AnalytesData
          this.standardData = res.data.StandardData
          for (var i = 0; i < this.analytesData.length; i++) {
            //yAxis
            var serieData = this.analytesData[i]
            if (serieData != null) {
              var config = this.constructArgumentForSingleDataset(serieData, i)
              args.datasets.push(config.dataset)
              args.yAxis.push(config.yAxis)
            }

            var timeSeriesColor = Highcharts.getOptions().colors[i % 10]
            var detectionLimits = serieData.Points.map(x => x.DetectionLimit)
            var comments = serieData.Points.map(x => x.Comment)
            
            datasetsArgs.push({
              color: timeSeriesColor,
              name: serieData.AnalyteName,
              type: 'line',
              yAxis: i,
            })
            //xAxis
            let yAxisArg = datasetsArgs[i]
            let guidelineData = this.mapGuidelineData(serieData.AnalyteName,
              i,
              yAxisArg.type,
              serieData.Unit,
              this.guidelineLineColor)

            var points = serieData.Points.map(x => [moment(x.DateTime).valueOf(), x.Value])
            var self = this
            for (var j = 0; j < points.length; j++) {
              if(guidelineData.data != null) {
                let matchedGuideinePoint = guidelineData.data.find(x => x[0] == points[j][0])
                if(matchedGuideinePoint != null && matchedGuideinePoint[1] != null && points[j][1] >= matchedGuideinePoint[1]) {
                  //console.log('Excceedance')
                  points[j] = {
                    x: points[j][0],
                    y: points[j][1],
                    color: self.exceedancePointColor,
                    marker: {
                      fillColor: self.exceedancePointColor,
                      lineWidth: 2,
                      lineColor: timeSeriesColor,
                    },
                  }       
                  continue         
                }
              }
              

              if (detectionLimits && detectionLimits[j]) {
                var precision = self.getPrecisionByFloat(detectionLimits[j], 20)
                if (!self.floatGreaterThan(points[j][1], detectionLimits[j], precision)) {
                  points[j] = {
                    x: points[j][0],
                    y: points[j][1],
                    marker: {
                      fillColor: '#FFFFFF',
                      lineWidth: 2,
                      lineColor: timeSeriesColor,
                    },
                  }
                }
              }             
            }
            
            data.push({
              name: serieData.AnalyteName,
              data: points,
              detectionLimits: detectionLimits,
              comments: comments,
              yAxis: i,
              type: yAxisArg.type,
              unit: serieData.Unit,
              color: timeSeriesColor,
            })
            
            data.push(guidelineData)
          }
        }).catch((error) => {
          //console.log(error)
          if (this.$parent.$parent.isActive) {
            this.errorModal = true
            this.errorModalData = error.response.data
          }
        })
        return data
      },
      onErrorModalClose() {
        this.errorModal = false
        this.errorModalData = {}
      },
      mapGuidelineData(analyteName, yAxis, type, unit, color) {
        var data = {}
        var matchedGuidelineData = this.standardData.find(x => x.AnalyteName === analyteName)
        if (matchedGuidelineData != null) {
          data = {
            name: analyteName + ' Guideline: ' + matchedGuidelineData.GuidelineName,
            yAxis: yAxis,
            unit: unit,
            color: color,
            type: type === 'line' ? 'line' : 'arearange',
            dashStyle: 'Dash',
            fillOpacity: 0.3,
            data: matchedGuidelineData.StandardValuePoints.map(x => {
              if (type === 'line') {
                return [moment(x.DateTime).valueOf(), x.Value]
              } else {
                return [moment(x.DateTime).valueOf(), x.Min, x.Max]
              }
            }),
          }
        }
        return data
      },
      // Optimize guidelineData function
      // guidelineDataOptimize () { 
      //   var newGuidelineData = 
      //   matchedGuidelineData.StandardValuePoints.map(x => {
      //     if(type === 'line') {
      //       return [moment(x.DateTime).valueOf(), x.Value]
      //     }
      //     else {
      //       return [moment(x.DateTime).valueOf(), x.Min, x.Max]
      //     }
      //   })
      //   if(newGuidelineData[0].length === 2) {
      //     var allYData = []
      //     newGuidelineData.map(x => {
      //       allYData.push(x[1])
      //     })
      //     if(Math.max.apply(null, allYData) === Math.min.apply(null, allYData)) {
      //       newGuidelineData.splice(1, newGuidelineData.length-2)
      //     }
      //   }
      //   return newGuidelineData
      // },
      drawChartWithArgsIncludeCOC(args, data, waterQualityStandard) {
        var self = this
        for (var j = 0; j < data.length; j++) {
          if (data[j].data != undefined) {
            var index = data[j].yAxis
            if (args.yAxis[index] != undefined) {
              args.yAxis[index].title.text = data[j].name + ' ' + data[j].unit
              args.yAxis[index].min = 0
            }
          }
        }

        var _series = []
        var _credits = null
        var _chartdiv = 'chartdiv0' // chartdiv0 to chartdiv15
        for (j = 0; j < args.yAxis.length; j++) {
          _series = []
          data[j * 2].yAxis = 0 // reset the index
          _series.push(data[j * 2])
          args.title = data[j * 2].name + ' ' + data[(j * 2)].unit
          
          _chartdiv = 'chartdiv' + j.toString()

          var GuidelineName = ''
          if (!waterQualityStandard) {
            GuidelineName = waterQualityStandard.GuidelineName
          }
          // for N/A guideline
          if (data[(j * 2) + 1].data == undefined) {
            _credits = {
              text: 'Guideline ' + GuidelineName + ' not available for ' + data[j * 2].name + '.',
              style: { 'fontSize': '11px', 'margin': '0px' },
            }
          } else {
            _credits = { enabled: false }
            data[(j * 2) + 1].yAxis = 0
            _series.push(data[(j * 2) + 1])
          }

          Highcharts.setOptions({
            time: {
              useUTC: false,
            },
          })

          new Highcharts.chart(_chartdiv, {
            chart: {
              zoomType: 'xy',
              panning: true,
              panKey: 'shift',
              resetZoomButton: {
                position: {
                  align: 'left',
                  verticalAlign: 'top',
                  x: 50,
                },
                relativeTo: 'chart',
                theme: {
                  fill: 'white',
                  stroke: 'silver',
                  padding: 3,
                },
              },
              events: {
                load: function() {
                  var label = this.renderer.label('Hollow symbols represent values below detection limits and ' +
                      'solid symbols represent values above detection limits.')
                    .css({
                      width: '300px',
                      fontSize: '10px',
                    })
                    .attr({
                      'stroke': 'silver',
                      'stroke-width': 1,
                      'r': 2,
                      'padding': 5,
                      'margin-top': 5
                    })
                    .add()

                  label.align(Highcharts.extend(label.getBBox(), {
                    align: 'center',
                    x: 0, // offset
                    verticalAlign: 'bottom',
                    y: 0, // offset
                  }), null, 'spacingBox')
                },
              },
              marginBottom: 120,
            },
            credits: _credits, //{enabled: false},
            tooltip: {
              useHTML: true,
              valueDecimals: 3,
              style: {
                pointerEvents: 'auto',
              },
              formatter: function() {                
                var precision = self.getPrecisionByFloat(this.y, 3)
                return '<b>' + this.series.name + '</b><br/>' +
                  Highcharts.dateFormat('%b. %e, %Y %H:%M', this.x) + ' ' + this.y.toFixed(precision) + ' ' + this.series.options.unit + '<br/>' +
                  self.getDetectionLimit(this.point.index, this.series, data) + this.series.options.unit + '<br/>' +
                  self.getImportByCocCode(this.point.index, this.series.name) + '<br/>' +
                  self.getComment(this.point.index, this.series, data) + '<br/>'
                // 'COC Code:<a href="' + self.getImportByCocCode(this.point.index, this.series.name) + '">link</a>' + '<b>' + 'COC Code' + '</b>' 
              },
              hideDelay: 50,
            },
            title: {
              text: args.title,
            },
            legend: {
              useHTML: true,
              align: 'center',
              verticalAlign: 'top',
              layout: 'horizontal',
              labelFormatter: function () {
                return '<span style="display: inline-block; max-width: 180px; overflow-wrap: break-word; word-wrap: break-word; white-space: normal; vertical-align: middle;">' + this.name + '</span>'
              },
            },
            subtitle: {
              text: 'Click on points to view details.  Click and drag to zoom in. Hold down shift key to pan.',
            },
            xAxis: {
              type: 'datetime',
              dateTimeLabelFormats: { // don't display the dummy year
                day: '%b. %e',
                month: '%b. %Y',
                year: '%Y',
              },
            },
            yAxis: {
              title: {
                text: data[(j * 2)].unit,
              },
              min: 0,
            },
            plotOptions: {
              series: {
                stickyTracking: false,
                marker: {
                  enabled: true,
                },
              },
            },
            series: _series,
            exporting: self.makeExportingConfig(),
          })
        }
      },


      getImportByCocCode(pointIndex, name) {
        var foundGraphData = this.rawGraphData.find(x => x.AnalyteName == name)
        if (foundGraphData) {
          var matchedPoint = foundGraphData.Points[pointIndex]
        } else {
          var htmlGuideline = '<b><a target="_blank"></a></b>'
          return htmlGuideline
        }
        var cocCode = matchedPoint.CocCode
        if (cocCode == null) {
          return 'COC Code: <b>Unknown</b>'
        } else {
          var matchedImport = this.importlist.find(x => x.coc_code == cocCode)
          if (matchedImport == null) {
            return 'COC Code: <b>Unknown</b>'
          }
          var importLink = this.$router.resolve(`/import/${matchedImport.id}`).href
          var html = `COC Code: <b>${matchedImport.coc_code}</b><br/><a href='${importLink}'>Import Detail</a> | <a href='/uploads/${matchedImport.filename}'>Source File</a>`

          var samples = this.$store.getters['sampleactivity/samples']
          var documents = [].concat.apply([], samples.filter(x => x.CocCode == cocCode).map(x => x.Documents))

          if (documents.length > 0) {
            var firstDocument = documents[0]
            html += ` | <a target="blank" href="/uploads/${firstDocument.FileName}">Sample Document</a>`
          }
          return html
          //return 'COC Code: <b><a target="_blank">' + cocCode + '</a></b>'
        }
      },
      getDetectionLimit(pointIndex, series, data) {
        var dataSeries = data.filter(x => x.name == series.name)[0]
        if (!dataSeries || !dataSeries.detectionLimits || !dataSeries.detectionLimits[pointIndex]) {
          return 'Detection Limit: Unknown '
        }
        var detectionLimit = dataSeries.detectionLimits[pointIndex]
        var precision = this.getPrecisionByFloat(detectionLimit, 3)

        var html = `Detection Limit: ${detectionLimit.toFixed(precision)} `

        return html
      },
      getComment(pointIndex, series, data) {
        var dataSeries = data.filter(x => x.name == series.name)[0]
        if (!dataSeries || !dataSeries.comments || !dataSeries.comments[pointIndex]) {
          return 'Comment: Unknown '
        }
        var comment = dataSeries.comments[pointIndex]
        var html = `Comment: ${comment} `
        
        return html
      },

      generateDashCharts() {
        //console.log('generateDashCharts... ' )
        var _gData = this.graphRequestData
        var args = {
          title: 'Dashboard of 16 charts',
          timeRange: [_gData.startDate, _gData.endDate],
          datasets: [],
          yAxis: [],
        }

        this.hasError = false
        var requestData = {
          RoleName: this.currentUserGroup.name,
          StartDate: newDateStringNoTimezone(_gData.startDate),
          EndDate: newDateStringNoTimezoneAddOneDay(_gData.endDate),
          StationName: _gData.stationName,
          StationId: _gData.stationId,
          IncludeQaQc: false,
          WaterQualityStandards: _gData.media.match('Water') ? _gData.guidelines : [],
          Media: _gData.media,
        }

        //console.log('generateDashCharts.requestData: ' + JSON.stringify(requestData))
        try {
          var datasetsArgs = []
          this.fetchDashGraphsData(args, datasetsArgs, requestData).then(wqData => {
            this.errorHtml = null
            this.hasError = false
            this.loading = false
            if (!!this.analytesData && this.analytesData.length == 0) {
              this.hasError = true
              this.loading = false
              this.errorHtml = 'There was no data within this date range.'
            } else {
              try {
                var standard = {}
                if (requestData.WaterQualityStandards != null && requestData.WaterQualityStandards.length != 0) {
                  standard = requestData.WaterQualityStandards[0]
                }
                this.drawChartWithArgsIncludeCOC(args, wqData, standard)
              } catch (e) {
                this.hasError = true
                this.loading = false
                this.$jsnLog().error((e && e.toString()) || '')
                this.errorHtml = 'The system failed to draw the graph with data. Please try again.'
              }
            }
            
          }).catch((e) => {
            this.hasError = true
            this.loading = false
            this.$jsnLog().error((e && e.toString()) || '')
            this.errorHtml = 'The system failed to fetch data for the graph. Please try again.'
          })
        } catch (e) {
          this.hasError = true
          this.loading = false
          this.$jsnLog().error((e && e.toString()) || '')
          this.errorHtml = 'The system failed to generate parameters to fetch data for graph. Please try again.'
        }
      },
      hasData(id) {
        if (this.analytesData) {
          return id < this.analytesData.length
        } else {
          return true
        }
      },
    },

  }
</script>
<style lang="" scoped>
</style>